var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarW(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1429 15.1724V32.2759C13.1429 34.0601 12.9909 35.9614 12.1806 37.557C12.0617 37.7909 12 38.0491 12 38.3117C12 39.2441 12.7669 40 13.7131 40H29.7142C30.6605 40 31.4273 39.2441 31.4273 38.3117C31.4273 38.0491 31.3656 37.7909 31.2467 37.557C30.4365 35.9614 30.2856 34.0601 30.2856 32.2759V15.1724",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7144 19.0343V35.5861",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7141 19.0343V35.5861",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7141 19.0343V35.5861",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4285 9.1035C28.833 9.1035 28.2833 9.27233 27.809 9.54929C27.4262 8.64226 26.5062 8.00005 25.4285 8.00005C24.2845 8.00005 23.3256 8.72722 22.9919 9.72474C22.4091 8.70184 21.2948 8.00005 20 8.00005C18.7805 8.00005 17.7165 8.61909 17.1085 9.54488C16.6103 9.27233 16.0423 9.1035 15.4286 9.1035C13.5348 9.1035 12 10.5854 12 12.4138C12 14.2423 13.5348 15.7242 15.4286 15.7242C15.4811 15.7242 15.5291 15.7109 15.5817 15.7087C16.1577 16.3863 17.0217 16.8276 18 16.8276C19.3188 16.8276 20.4445 16.042 20.9097 14.9297C21.4605 16.0486 22.6319 16.8276 23.9999 16.8276C25.5896 16.8276 26.9142 15.7772 27.3028 14.3603C27.8628 14.8602 28.6056 15.1725 29.4285 15.1725C31.1645 15.1725 32.5713 13.8141 32.5713 12.138C32.5713 10.4618 31.1645 9.1035 29.4285 9.1035Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2856 31.4259C30.8216 31.9654 31.4274 32.2766 32.0708 32.2766C34.2411 32.2766 35.9999 30.222 35.9999 25.9561V23.1478C35.9999 18.8819 34.2411 16.8283 32.0708 16.8283C31.4274 16.8283 30.8216 17.1384 30.2856 17.678",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0713 32.2758H30.2861",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0713 16.8276H30.2861",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarW);
export default __webpack_public_path__ + "static/media/bar-w.d29d1bb3f92cc6029b42734017a30548.svg";
export { ForwardRef as ReactComponent };